import 'twin.macro';
import React from 'react';
import { CarnetSearchResult } from '@teetsh/app/src/containers/Search/types';
import { format } from '@teetsh/app/src/utils/time/format';
import { CalendarIcon as Calendar } from '@heroicons/react/24/outline';
import _orderBy from 'lodash-es/orderBy';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';

interface Props {
  carnet: CarnetSearchResult;
}

export function CarnetPreview(props: Props) {
  const { carnet } = props;
  const { locale } = useUser();
  const { t } = useTranslation(['common']);

  return (
    <div tw="p-6">
      <div tw="text-xl font-bold mb-4">{carnet.name}</div>
      <div tw="space-y-3">
        {_orderBy(carnet.evaluations, ['date'], ['asc']).map(ev => (
          <div key={ev.id}>
            <p tw="font-medium">{ev.name}</p>
            <div tw="flex items-center text-sm text-neutral-quiet mt-1">
              <Calendar tw="mr-1.5 h-5 w-5 shrink-0 text-neutral-quiet" />
              <p>
                {ev.date
                  ? format(ev.date, locale, 'eeee dd MMMM yyyy')
                  : t('common:search.results.noDate')}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
